import { Box, Grid, Stack, styled, Typography } from '@mui/material';
import { getUrlExtension } from 'utils/globalFunction';
import { getFileTypeFromExt } from 'xeniautils';
import { FILE_TYPES } from 'components/FileUpload/utils';

export const FileItemContainer = styled(Box)(() => ({
  height: 44,
  width: '100%',
  borderRadius: 8,
  padding: 8,
  gap: 10,
  border: '1px solid rgba(224, 224, 224, 1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'rgba(240, 243, 244, 1)',

  '& .FileName': {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
    whiteSpace: 'pre',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },

  '&:hover': {
    '& .FileName': {
      textDecoration: 'underline',
    },
  },

  '& .cancelIcon': {
    cursor: 'pointer',
    color: 'rgba(239, 83, 80, 1)',
  },

  '& .downloadBtn': {
    display: 'none',
    '&:hover': {
      background: 'transparent',
    },
    fontWeight: 500,
    fontSize: 13,
    lineHeight: '100%',
    letterSpacing: 0,
    transition: 'all 0.3s ease',
    '& path': {
      fill: 'rgba(78, 72, 250, 1)',
    },
  },
}));

const ActionItemIcon = styled(Box, {
  shouldForwardProp: (prop) => !['bgcolor', 'svgdimensions'].includes(prop),
})(({ bgcolor, svgdimensions = {} }) => ({
  marginRight: 10,
  backgroundColor: bgcolor,
  height: '28px',
  width: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  gap: '10px',
  '& > svg': {
    ...svgdimensions,
  },
}));

const ChecklistLogReportAppendixFiles = function ({
  appendixAttachment,
  attachmentIndex,
  previewAttachment,
}) {
  const attachment = appendixAttachment?.url;

  const extension = getUrlExtension(attachment);
  const type = getFileTypeFromExt(extension);
  const fileTypeData = FILE_TYPES[type];

  const FileTypeIcon = fileTypeData?.icon;
  const fileName = attachment.split('/').pop() || '';
  return (
    <Grid
      item
      xs={12}
      sx={{
        marginTop: '-10px',
      }}
    >
      <FileItemContainer
        key={attachment + '_' + attachmentIndex}
        onClick={() => previewAttachment(attachmentIndex)}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          {FileTypeIcon && (
            <ActionItemIcon
              bgcolor={fileTypeData.bgColor}
              svgdimensions={fileTypeData.styles}
            >
              <FileTypeIcon />
            </ActionItemIcon>
          )}
          <Typography className="FileName">{fileName}</Typography>
        </Stack>
      </FileItemContainer>
    </Grid>
  );
};

export default ChecklistLogReportAppendixFiles;
